import { RootState } from '../types';

export const auctionSelector = ({ auctions }: RootState) => auctions;
